import { WithdrawalCancel, WithdrawalCreate } from '@app/shared/ui/molecules/Withdrawal';
import { WithdrawalModel } from '@app/store/slices/withdrawal/withdrawalTypes';

interface Props {
  withdrawal?: WithdrawalModel | null;
}

export function WithdrawalCards({ withdrawal }: Props) {
  return withdrawal ? <WithdrawalCancel withdrawal={withdrawal} /> : <WithdrawalCreate />;
}
